import { Component, OnDestroy, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_PortalAppBatchRegistration } from "../shared/data.service";
import { PortalAppExportRequest } from "../shared/portal-app-export-request";

@Component({
	selector: "caass-portal-app-batch-export",
	templateUrl: "./portal-app-batch-export.component.html",
	styleUrls: ["./portal-app-batch-export.component.css"],
})
export class PortalAppBatchExportComponent implements OnInit, OnDestroy {
	constructor(private ref: DynamicDialogRef, private selectService: SchoolselectorService, private dataService: DataService_PortalAppBatchRegistration) {}

	ngOnInit(): void {
		this.AppType = this.lstAppType[0];

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});

		this.loadPersonType();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////

	subscription: any;

	Processing: boolean = false;

	AppType: any;
	lstAppType: any = [
		{
			ID: 1,
			Desc: "Parent Portal",
		},
		{
			ID: 2,
			Desc: "Student Portal",
		},
		{
			ID: 3,
			Desc: "Staff Portal",
		},
	];

	School: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	GradeLevelID: number = -1;
	lstGradeLevel: any = [];

	AcademyID: number = -1;
	lstAcademy: any = [];

	HomeroomID: number = -1;
	lstHomeroom: any = [];

	GroupID: number = -1;
	lstGroup: any = [];

	Active: number = 1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	PersonTypeID: number = -1;
	lstPersonType: any = [];

	HasEmail: number = 1;
	lstHasEmail: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Has Email",
		},
		{
			ID: 2,
			Desc: "No Email",
		},
	];

	LoadingGradeLevel: boolean = false;
	LoadingAcademy: boolean = false;
	LoadingHomeroom: boolean = false;
	LoadingGroup: boolean = false;
	LoadingPersonType: boolean = false;

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////

	loadGradeLevel() {
		this.LoadingGradeLevel = true;

		var result = this.dataService.GradeLevelSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				this.GradeLevelID = this.lstGradeLevel[0].GradeLevelID;

				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	loadAcademy() {
		this.LoadingAcademy = true;

		var result = this.dataService.AcademySelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				this.AcademyID = this.lstAcademy[0].AcademyID;

				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	loadHomeroom() {
		this.LoadingHomeroom = true;

		var result = this.dataService.HomeroomSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				this.HomeroomID = this.lstHomeroom[0].HomeroomID;

				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	loadGroup() {
		this.LoadingGroup = true;

		var result = this.dataService.GroupSelectList(this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				this.GroupID = this.lstGroup[0].GroupID;

				this.LoadingGroup = false;
			},
			(error) => {
				this.LoadingGroup = false;
			}
		);
	}

	loadPersonType() {
		this.LoadingPersonType = true;

		var result = this.dataService.PersonTypeSelectList();
		result.subscribe(
			(response) => {
				this.lstPersonType = response;

				this.PersonTypeID = this.lstPersonType[0].PersonTypeID;

				this.LoadingPersonType = false;
			},
			(error) => {
				this.LoadingPersonType = false;
			}
		);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onExport() {
		this.Processing = true;

		var parms: PortalAppExportRequest = {
			AppTypeID: this.AppType.ID,
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevelID,
			AcademyID: this.AcademyID,
			HomeroomID: this.HomeroomID,
			GroupID: this.GroupID,
			Active: this.Active,
			PersonTypeID: this.PersonTypeID,
			HasEmail: this.HasEmail,
		};

		var result = this.dataService.PortalAppExportSelectList(parms);
		result.subscribe(
			(response: any) => {
				// console.log(response);

				var a = document.createElement("a"); //Create <a>

				var FormattedAppType = this.ReplaceAllOccur(this.AppType.Desc, " ", "_");
				var FormattedSchoolName = this.ReplaceAllOccur(this.School.SchoolName, " ", "_");

				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "<", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, ">", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, ":", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "\\", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "/", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "|", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "?", "_");
				FormattedSchoolName = this.ReplaceAllOccur(FormattedSchoolName, "*", "_");

				var FileName = "Export_" + FormattedAppType + "_" + FormattedSchoolName + "_" + this.AppType.Desc.replace(" ", "_");
				a.href = "data:text/plain;base64," + response.str;
				a.download = FileName + ".txt";

				this.Processing = false;

				a.click(); //Downloaded file
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;

		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////

	IsLoading() {
		return (
			this.LoadingGradeLevel == true ||
			this.LoadingAcademy == true ||
			this.LoadingHomeroom == true ||
			this.LoadingGroup == true ||
			this.LoadingPersonType == true ||
			this.Processing == true
		);
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		// console.log("Replace");
		// console.log(source);

		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	StudentMode() {
		return this.AppType.ID == 1 || this.AppType.ID == 2;
	}

	StaffMode() {
		return this.AppType.ID == 3;
	}

	/////////////////////////////////////////////////////////
}
